import type { LinkProps as BaseLinkProps } from '@online-webinar/router';
import { Link as BaseLink } from '@tanstack/react-router';

export interface LinkProps extends BaseLinkProps {
    classNames?: string;
    iconbtn?: boolean;
    variant?: string;
}

export const Link = ({ children, classNames = '', iconbtn, variant, disabled, ...props }: LinkProps) => (
    <BaseLink
        className={`btn ${iconbtn ? 'btn--icon' : ''} ${variant == 'primary' ? 'btn--primary' : ''} ${variant == 'primary-outline' ? 'btn--outline-primary' : ''} ${variant == 'white-outline-transparent' ? 'btn--outline-white' : ''} ${variant == 'secondary' ? 'btn--secondary' : ''} ${variant == 'secondary-outline' ? 'btn--outline-secondary' : ''} ${variant == 'success' ? 'btn--success' : ''} ${variant == 'success-outline' ? 'btn--outline-success' : ''} ${variant == 'warning' ? 'btn--warning' : ''} ${variant == 'warning-outline' ? 'btn--outline-warning' : ''} ${variant == 'link' ? 'btn--link' : ''} ${disabled ? 'opacity-60 pointer-events-none' : ''} ${classNames}`}
        disabled={disabled}
        {...props}
    >
        {children}
    </BaseLink>
);
